import { Button } from "@/components/ui/button";
import { useCopyToClipboard } from "@/hooks";
import { Copy, Eye, EyeOff } from "lucide-react";

interface JsonViewerHeaderProps {
  title: string;
  jsonString: string;
  showRaw: boolean;
  onToggleRaw: (show: boolean) => void;
  showCopyButton?: boolean;
  showToggleRaw?: boolean;
}

export function JsonViewerHeader({
  title,
  jsonString,
  showRaw,
  onToggleRaw,
  showCopyButton = true,
  showToggleRaw = true,
}: JsonViewerHeaderProps) {
  const { copyToClipboard, isCopied } = useCopyToClipboard({
    showToast: true,
    successMessage: "JSON copied to clipboard",
  });

  const handleCopy = () => {
    copyToClipboard(jsonString);
  };

  const handleToggleRaw = () => {
    onToggleRaw(!showRaw);
  };

  return (
    <div className="flex items-center justify-between mb-2 border-b">
      <h4 className="text-sm font-medium text-foreground pb-2">{title}</h4>
      <div className="flex items-center gap-2">
        {showToggleRaw && (
          <Button
            variant="ghost"
            size="sm"
            onClick={handleToggleRaw}
            className="h-6 px-2"
          >
            {showRaw ? (
              <EyeOff className="h-3 w-3" />
            ) : (
              <Eye className="h-3 w-3" />
            )}
            {showRaw ? "Formatted" : "Raw"}
          </Button>
        )}
        {showCopyButton && (
          <Button
            variant="ghost"
            size="sm"
            onClick={handleCopy}
            className="h-6 px-2"
            disabled={isCopied}
          >
            <Copy className="h-3 w-3" />
            {isCopied ? "Copied!" : ""}
          </Button>
        )}
      </div>
    </div>
  );
}
